import React from 'react';
import FormSwitch from '@common/FilterInputs/Switch';

const FormSwitchWrapper = props => {
  return <FormSwitch {...props} viewType="switch" />;
};

export default FormSwitchWrapper;
